import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { X, PhoneCall } from 'lucide-react';
import { Button } from '../ui/button';
import { CONTACT } from '../../data/siteData';

export const ExitPopup = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onLeave = (e) => {
      if (e.clientY <= 8 && !sessionStorage.getItem('wl_exit_shown')) {
        sessionStorage.setItem('wl_exit_shown', '1');
        setOpen(true);
      }
    };
    const timer = setTimeout(() => document.addEventListener('mouseout', onLeave), 8000);
    return () => { clearTimeout(timer); document.removeEventListener('mouseout', onLeave); };
  }, []);

  if (!open) return null;

  return (
    <div data-testid="exit-popup" className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-[#0A192F]/60 backdrop-blur-sm">
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 text-center">
        <button data-testid="exit-popup-close" onClick={() => setOpen(false)} aria-label="Close popup"
          className="absolute top-4 right-4 p-1.5 rounded-full text-slate-400 hover:bg-slate-100 hover:text-slate-700 transition-colors">
          <X className="w-5 h-5" />
        </button>
        <div className="w-14 h-14 mx-auto rounded-full bg-[#0A192F] flex items-center justify-center mb-5">
          <PhoneCall className="w-6 h-6 text-white" />
        </div>
        <h3 className="text-2xl font-bold text-[#0A192F] font-heading">Before you go —</h3>
        <p className="text-slate-600 mt-3 text-sm leading-relaxed">
          Get a <strong>free 30-minute workforce consultation</strong> with our solutions team.
          We&apos;ll map your requirement and share a deployment plan — no commitment needed.
        </p>
        <div className="flex flex-col gap-3 mt-6">
          <Button asChild data-testid="exit-popup-book" className="bg-[#0066CC] hover:bg-[#0052A3] text-white w-full">
            <a href={CONTACT.calendly} target="_blank" rel="noopener noreferrer">Book Free Consultation</a>
          </Button>
          <Button asChild variant="outline" data-testid="exit-popup-contact" className="border-[#0A192F] text-[#0A192F] w-full" onClick={() => setOpen(false)}>
            <Link to="/#contact">Request a Call Instead</Link>
          </Button>
        </div>
      </div>
    </div>
  );
};
